import { useEffect, useState } from "react";
import { BLOG_CRUMB } from "../../constants/BreadcrumConstants";
import MenuHeader from "../header/MenuHeader";
import { makeGetRequest } from "../../rest/RestService";
import { BLOG_DETAIL_URL, BLOG_OG_URL } from "../../constants/APIEndpointConstants";
import { Loader } from "../general/Loader";
import { useParams } from "react-router-dom";
import { HTMLParserHelper } from "../../helper/HTMLParserHelper";
import { Helmet } from "react-helmet";
import { ABOUT } from "../../constants/PageTitleConstants";
import "../../assets/css/style.min.css";
import { sanitizeHTML } from "../../helper/SanitizeHTML";
import { mnthInitials } from "../../helper/MonthInitials";
import "../../assets/css/bookDetail.css";
import "../../assets/css/share-svg.css";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { ManageScroll } from "../../helper/ManageScroll";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import PageNotFound from "../not-found/PageNotFound";

const BlogDetail = () => {
  const { blog } = useParams();
  const [titleRef, setTitleRef] = useState();
  const [blogs, setBlogs] = useState({});
  const [loader, setLoader] = useState(true);
  const [socailLink, setSocialLink] = useState({});
  const [ogUrl,setOgUrl] = useState("");
  const history = useHistory();
  const { hfData, error: hfError } = useSelector((state) => state.hfReducer);
  useEffect(() => {
    if (!document.getElementById("social-sharing-script")) {
      var ssScript = document.createElement("script");
      var inlineScript = document.createTextNode(
        'function theChampPopup(e) {window.open(e,"_blank","height=420,width=620,left=390,top=105,resizable,scrollbars,toolbar=0,personalbar=0,menubar=no,location=no,directories=no,status");}'
      );
      ssScript.appendChild(inlineScript);
      ssScript.id = "social-sharing-script";
      document.head.appendChild(ssScript);
    }
    setLoader(true);
    if (hfData?.header) {
      const url = `${BLOG_DETAIL_URL}${blog}`;
      const blog_og_url = `${BLOG_OG_URL}/${blog}`;
      makeGetRequest(url)
        .then((res) => {
          setBlogs(res.data[0]);
          setSocialLink(res.data[0]?.sociallinks);
        })
        .catch((err) => setBlogs({ error: err.message }))
        .finally(() => {
          // getting OG URL for SEO from API
          makeGetRequest(blog_og_url)
          .then((res)=>{
            setOgUrl(res.data);
          })
          .catch((err)=>setOgUrl({yoast_head_json:"https://www.politybooks.com"}));

          setLoader(false);
          ManageScroll(history);
        });
    }
  }, [blog, history, hfData?.header]);
  const blogDate = new Date(blogs?.modified);
  return (
    <>
      {loader ? (
        <Loader />
      ) : blogs?.content?.rendered && !hfError ? (
        <>
          <Header data={hfData} />
          <div className="container-fluid blog_bg">
          <Helmet>
            
            blogs?.yoast_head?      
            <meta name="description" content={blogs?.yoast_head_json?.og_description} />
            <meta property="og:url" content={ogUrl?.yoast_head_json?.og_url} />
            <meta property="og:type" content={blogs?.yoast_head_json?.og_type} />
            <meta property="og:title" content={blogs?.yoast_head_json?.title} />
            <meta property="og:description" content={blogs?.yoast_head_json?.og_description} />
            <meta property="og:image" content={blogs?.yoast_head_json?.og_image[0]?.url} />
            <meta property="og:image:secure_url" content={blogs?.yoast_head_json?.og_image[0].url} />
            <meta property="og:image:alt" content={blogs?.yoast_head_json?.og_description} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:locale" content={blogs?.yoast_head_json?.og_locale} />
            <meta property="og:site_name" content={blogs?.yoast_head_json?.og_site_name} />            
            <meta name="twitter:card" content={blogs?.yoast_head_json?.twitter_card} />
            <meta name="twitter:title" content={blogs?.yoast_head_json?.title} />
            <meta name="twitter:description" content={blogs?.yoast_head_json?.og_description} />
            <meta name="twitter:label1" content="Written by" />
            <meta name="twitter:data1" content={blogs?.yoast_head_json?.twitter_misc["Written by"]} />
            <meta name="twitter:label1" content="Est. reading time" />
            <meta name="twitter:data1" content={blogs?.yoast_head_json?.twitter_misc["Est. reading time"]} /> 
            :
            <title>{titleRef?.innerText?.concat(ABOUT)}</title>

              {/* <meta property="og:image" content="" />
              <meta property="og:image:secure_url" content={"No Image"} />
              <meta property="og:site_name" content="Polity | Polity Blogs" /> */}
            </Helmet>
            {/* WEB-331 - fixing the title issue using dangerouslySetInnerHTML  */}
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <MenuHeader
                  crumbs={[
                    BLOG_CRUMB,
                    {
                      title: blogs?.title?.rendered,
                    },
                  ]}
                  textColor="subject_intro_text"
                  breadCrumbColor="subject_padding"
                  labelColor="lable_hlight"
                />
                <div className="container-fluid refine_section">
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="container subject_padding">
                        <div className="row">
                          <div
                            className="col-xs-12 col-sm-12 col-md-12 col-lg-12 subject_intro_text"
                            style={{ paddingTop: "0px" }}
                          >
                            <div className="row">
                              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="circle">
                                  <span className="ndate">
                                    {blogDate?.getDate()}
                                  </span>
                                  <span className="nmonth">
                                    {mnthInitials[blogDate?.getMonth()]}
                                  </span>
                                </div>
                                <div className="blog_title_single pull-left">
                                  <h2
                                    className="blog_title_new"
                                    dangerouslySetInnerHTML={sanitizeHTML(
                                      blogs?.title?.rendered
                                    )}
                                    ref={(e) => setTitleRef(e)}
                                  ></h2>

                                  <div className="blog_tagline_info">
                                    Posted By polity_admin_user
                                  </div>
                                </div>
                              </div>
                              <div className="blog_content">
                                {HTMLParserHelper(blogs?.content?.rendered)}
                              </div>
                              <div
                                dangerouslySetInnerHTML={{ __html: socailLink }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer data={hfData} />
        </>
      ) : (
        <>
          <PageNotFound pageError={blogs?.error || hfError} />
        </>
      )}
    </>
  );
};
export default BlogDetail;
